<template>
  <el-row style="height: 100%;background:#044578;color:#ffffff">
    <el-col style="height:300px;position: absolute;top: 50%;margin-top:-150px">
      <el-row>
        <el-col :span="20" :offset="2" style="font-size: 30px"
          >AIO5系统监控大屏</el-col>
        </el-row>
        <el-row style="max-width:500px;margin:auto;margin-top: 1.5%">
          <!-- <el-col :span="16" :offset="4" style="margin-top: 10px" v-show="radio==1">
            <el-input
              placeholder="请输入经销商主账号"
              prefix-icon="el-icon-user-solid"
              v-model="username1"
            >
            </el-input
          ></el-col> -->
          <el-col :span="16" :offset="4" style="margin-top: 10px">
            <el-input
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
              v-model="username"
            >
            </el-input
          ></el-col>
          <el-col :span="16" :offset="4" style="margin-top: 10px">
            <el-input
              show-password
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              v-model="password"
            >
            </el-input
          ></el-col>
          <el-col :span="16" :offset="4" style="margin-top: 10px" class="radio">
            <el-radio v-model="radio" label="1" style="color: aliceblue">经销商登录</el-radio>
            <el-radio v-model="radio" label="2" style="color: aliceblue">用户登录</el-radio>
          </el-col>
          <el-col :span="16" :offset="4" style="margin-top: 10%">
            <el-button
              style="width: 80%"
              type="success"
              round
              @click="login()"
            >
              登录</el-button
            ></el-col
          >
        </el-row>
    </el-col>
  </el-row>
</template>

<script>
import Vue from "vue";

import { hex_md5 } from "../assets/js/md5";

export default {
  name: "Login",
  data() {
    return {
      username1: "",
      username: "",
      password: "",
      radio: '1'
    };
  },
  mounted: function () {
   window.localStorage.clear()
  },
  methods: {
    login() {
      var self = this;
      if(self.radio == 1){//管理员与经销商登录
        if (!!!self.username || !!!self.password) {
          self.$message({
            showClose: true,
            message: "请输入用户名与密码",
            type: "error",
          });
          return false;
        }
        var dealer=self.username;
        var username=self.username;
        if(self.username.indexOf('@')>0){
          username=self.username.split('@')[0]
          dealer=self.username.split('@')[1]
        }
        Vue.axios.post("/api/aio/login", {
          username: username,
          password: hex_md5(self.password),
          dealer:dealer,
          type: 1
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            window.localStorage.setItem("sessionid", res.data.msgbody.uuid);
            window.localStorage.setItem(
              "customer",
              JSON.stringify(res.data.msgbody.customer)
            );
            self.$router.push({ name: "ProjectList" });
          } else {
            self.$message({
              showClose: true,
              message: res.data.errmsg,
              type: "error",
            });
          }
        });
      }else {//普通用户登录
        if (!!!self.username || !!!self.password) {
          self.$message({
            showClose: true,
            message: "请输入用户名与密码",
            type: "error",
          });
          return false;
        }
        Vue.axios.post("/api/aio/login", {
          username: self.username,
          password: hex_md5(self.password),
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            window.localStorage.setItem("sessionid", res.data.msgbody.uuid);
            window.localStorage.setItem(
              "customer",
              JSON.stringify(res.data.msgbody.customer)
            );
            self.$router.push({ name: "ProjectList" });
          } else {
            self.$message({
              showClose: true,
              message: res.data.errmsg,
              type: "error",
            });
          }
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .radio >>> .el-radio__label {
    color: aliceblue;
  } */
</style>



// WEBPACK FOOTER //
// src/components/Login.vue